import React from 'react';
import PropTypes from 'prop-types';

import { Banner } from '@buildoutinc/blueprint-react/ui/Banner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';

import Button from 'shared/button';

import './styles.scss';

const VARIANT_MAP = {
  danger: { variant: 'destructive', icon: faCircleExclamation },
  info: { variant: 'info', icon: faCircleInfo },
  success: { variant: 'success', icon: faCircleCheck },
  warning: { variant: 'warning', icon: faTriangleExclamation },
  vgCollectInfo: { variant: 'info', icon: faCircleInfo, className: 'banner--vg-collect-info' },
  vgVerification: { variant: 'info', icon: faCircleCheck, className: 'banner--vg-verification' },
  vgWaitlist: { variant: 'info', icon: faCircleInfo, className: 'banner--vg-waitlist' },
  vgSignCa: { variant: 'info', icon: faCircleInfo, className: 'banner--vg-sign-ca' },
};

export const LeadBanner = ({ callToAction, content, show = true, title, variant }) => {
  if (!show) return null;

  const config = VARIANT_MAP[variant] || VARIANT_MAP.info;

  return (
    <Banner className={classNames('align-items-center', config.className)} variant={config.variant}>
      <Banner.Content>
        <FontAwesomeIcon icon={config.icon} size="lg" />
        <div className="flex-fill">
          {title && <div><b>{title}</b></div>}
          {content && <div>{content}</div>}
        </div>
      </Banner.Content>
      {callToAction && (
        <Banner.Actions>
          {callToAction.detailsText && <span>{callToAction.detailsText}</span>}
          <Button.Accent outlined onClick={callToAction.onClick}>
            {callToAction.buttonText}
          </Button.Accent>
        </Banner.Actions>
      )}
    </Banner>
  );
};

LeadBanner.propTypes = {
  callToAction: PropTypes.shape({
    buttonText: PropTypes.string.isRequired,
    detailsText: PropTypes.string,
    onClick: PropTypes.func.isRequired,
  }),
  content: PropTypes.node,
  show: PropTypes.bool,
  title: PropTypes.node,
  variant: PropTypes.string,
};
